import { render, staticRenderFns } from "./testcomponents.vue?vue&type=template&id=77f90212"
import script from "./testcomponents.vue?vue&type=script&lang=js"
export * from "./testcomponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports